import { useMutation } from '@tanstack/react-query';
import { queryClient, QUERY_KEYS } from '@src/query';
import { ApiError } from '@src/services/api';
import { ApiTypes, CRMTemplateView } from 'common';
import { updateCrmTemplate } from './api';
import { BodyEditCRMTemplate } from 'common/dist/types/apiTypes';

export const useMutationEditCRMTemplate = () =>
  useMutation<CRMTemplateView, ApiError, ApiTypes.BodyEditCRMTemplate>({
    mutationFn: (template: BodyEditCRMTemplate) => updateCrmTemplate(template),
    onSuccess: async () => {
      const key = QUERY_KEYS.crmTemplates();
      queryClient.invalidateQueries({ queryKey: key });
    },
  });
